import { Link } from "react-router-dom";

export default function SiteFooter({ company }) {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-950 text-slate-200">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-3 lg:px-8">
        <div>
          <h3 data-testid="footer-company-name" className="font-heading text-2xl font-semibold text-white">
            {company.name}
          </h3>
          <p data-testid="footer-company-address" className="mt-4 text-sm leading-6 text-slate-300">
            {company.address}
          </p>
        </div>

        <div>
          <h4 data-testid="footer-contact-heading" className="text-sm font-semibold uppercase tracking-wider text-orange-300">
            Contact
          </h4>
          <a
            href={`tel:${company.phone.replace(/\s+/g, "")}`}
            data-testid="footer-phone-link"
            className="mt-4 block text-lg font-semibold text-white hover:text-orange-300"
          >
            {company.phone}
          </a>
          <p data-testid="footer-gst-number" className="mt-3 text-sm text-slate-300">
            GST: {company.gst}
          </p>
        </div>

        <div>
          <h4 data-testid="footer-links-heading" className="text-sm font-semibold uppercase tracking-wider text-orange-300">
            Quick Links
          </h4>
          <div className="mt-4 flex flex-col gap-2">
            <Link data-testid="footer-home-link" to="/" className="hover:text-white">
              Home
            </Link>
            <Link data-testid="footer-products-link" to="/products" className="hover:text-white">
              Products
            </Link>
            <Link data-testid="footer-contact-link" to="/contact" className="hover:text-white">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
